import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form, Input, Button, Checkbox, Row, Col, Spin, Tooltip } from "antd";
import { sendShareAsset } from "../../actions/AssetsShareAction";
import { VideoView } from "../assets-view/VideoView";
import DocumentView from "../document-view/DocumentView";
import { unsetSelectShareAsset } from "../../actions/ClientAction";
import Helper from "../helper/Helper";
import { sendNotification, getImageAssettByExtension } from "../../utils/index";
import "./share-asset.css";
// import Magnifier from "react-magnifier";
import { setkeyboardEnabled } from "../../actions/AppAction";
import BunkeyAPI from "../../api/BunkeyAPI";
import { fetchUsersToMentionAll } from "../../api/GroupApi";
import fileextension from "file-extension";
import SVGView from "../assets-view/SVGView";
import { Select } from "antd";
import { isEmail } from '../../utils/index'
import { isRightsDownloadBlocked } from "../../utils/rights";
const { TextArea } = Input;
const { Option } = Select;

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0",
};

export class ShareAsset extends Component {
  constructor(props) {
    super(props);

    this.myInputCopyLink = React.createRef();
    this.state = {
      emails: [],
      plainOptions: ["10", "30", "60", "90", "120"],
      selectedOption: "10",
      message: "",
      start: false,
      hasEmailError: false,
      showCopyLink: false,
      showPasswordInputs: false,
      addPassword: "",
      confirmPassword: "",
      copyLink: "",
      loadingButtonLink: false,
      isFetchingUsers: false,
      users: [],
      errorFetchingUsers: null,
      showSpinnerEmail: true
    };
  }

  isDownloadBlocked = () =>
    isRightsDownloadBlocked(this.props.itemShareSelected, this.props.modules);

  notifyBlockedDownload = () => {
    sendNotification(
      "warning",
      this.props.intl,
      this.props.intl.formatMessage({ id: "rights_download_blocked" })
    );
  };

  componentDidMount() {
    this.props.setkeyboardEnabled(true);
    this.fetchUsers();
  }

  componentDidUpdate(prevProps) {
    const { sended, error, intl, keyCollection } = this.props;
    const { start } = this.state;

    if (!sended && error && prevProps.error !== error) {
      this.setState({
        start: false
      });
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "error_message" })
      );
    } else if (!sended && start) {
      this.setState({
        start: false
      });
      this.props.unsetSelectShareAsset(keyCollection);
    }
  }

  handleEmails = tag => {
    this.setState({
      emails: tag.tags.map(r => {
        return r;
      })
    });
  };

  handleOnInputChange = e => {
    this.setState({
      message: e.target.value
    });
  };

  handleSendShared = () => {
    const { itemShareSelected, workclient, user, intl } = this.props;
    const {
      message,
      emails,
      hasEmailError,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      selectedOption
    } = this.state;

    if (this.isDownloadBlocked()) {
      this.notifyBlockedDownload();
      return;
    }

    // Si agrego contraseña
    if (showPasswordInputs) {
      // Y estas coinciden
      if (
        addPassword === confirmPassword &&
        confirmPassword !== "" &&
        addPassword !== ""
      ) {
        // Si el correo tiene errores
        if (hasEmailError) {
          this.setState({
            hasEmailError: false
          });
          return;
        } else {
          // Si el email es valido
          if (emails.length > 0) {
            this.props.sendShareAsset(
              workclient,
              user,
              itemShareSelected,
              message,
              confirmPassword,
              emails,
              intl
            );
            this.props.setkeyboardEnabled(false);
            this.setState({
              start: true
            });
          } else {
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "empty_email_share" })
            );
          }
        }
        // Si los inputs estan vacios
      } else if (addPassword === "" || confirmPassword === "") {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "must_enter_password" })
        );
        //  O si no son iguales
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "not_equal_passwords" })
        );
      }
      // Si no agrego contraseña
    } else if (hasEmailError) {
      this.setState({
        hasEmailError: false
      });
      return;
    } else {
      if (emails.length > 0) {
        this.props.sendShareAsset(
          workclient,
          user,
          itemShareSelected,
          message,
          "",
          emails,
          intl,
          parseInt(selectedOption)
        );
        this.props.setkeyboardEnabled(false);
        this.setState({
          start: true
        });
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "empty_email_share" })
        );
      }
    }
  };

  handleError = hasError => {
    this.setState({
      hasEmailError: hasError
    });
  };

  handleShowPasswordInputs = () => {
    const { showPasswordInputs } = this.state;
    this.setState({
      showPasswordInputs: !showPasswordInputs
    });
  };

  handleAddPass = e => {
    this.setState({
      addPassword: e.target.value
    });
  };

  handleConfirmPass = e => {
    this.setState({
      confirmPassword: e.target.value
    });
  };

  handleSendLinkShare = (itemShareSelected, user, workclient, changeSelectedOption) => {
    const { intl } = this.props;
    const { selectedOption } = this.state;

    if (this.isDownloadBlocked()) {
      this.notifyBlockedDownload();
      return;
    }

    this.setState(
      {
        loadingButtonLink: true
      },
      () =>
        BunkeyAPI({
          url: `/shared/getDownloadLink`,
          method: "POST",
          data: {
            object: itemShareSelected._id,
            user: user,
            client: workclient,
            password: "",
            expiresIn: changeSelectedOption ? parseInt(changeSelectedOption) : parseInt(selectedOption)
          }
        })
          .then(resp => {
            if (resp.data && resp.data.unavailable) {
              this.setState({ loadingButtonLink: false });
              this.notifyBlockedDownload();
              return;
            }
            this.setState({
              copyLink: resp.data,
              showCopyLink: true,
              loadingButtonLink: false
            });

            this.myInputCopyLink.current.focus();
            this.myInputCopyLink.current.setSelectionRange(0, 9999);
          })
          .catch(err => {
            this.setState({ loadingButtonLink: false });
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "error_copy_link" })
            );
          })
    );
  };
  handleSetSrc = r => {
    const { originalURL, lowQualityURL } = r;
    const itemUrl =
      originalURL !== lowQualityURL
        ? lowQualityURL
        : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  };

  fetchUsers = () => {
    console.log('entraaa => ');
    this.setState({ showSpinnerEmail: true })        
    const { workclient } = this.props;
    // const { itemShareSelected, workclient } = this.props;
    // fetchUsersToMentionFalse(workclient, itemShareSelected._id)
    fetchUsersToMentionAll(workclient, 1)
      .then(res => {
        // const { adminUsers, operatorUsers } = res.data;
        // console.log(res.data);
        // const usersMentions = [...adminUsers, ...operatorUsers];
        const usersMentions = res.data;
        const usersMentionsSorted = usersMentions.sort(
          (firstUser, secondUser) => {
            if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
              return -1;
            if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
              return 0;
            return 1;
          }
        );
        this.setState({ 
          users: usersMentionsSorted,
          showSpinnerEmail: false 
        });
      })
      .catch(err => {
        this.setState({ 
          errorFetchingUsers: err,
          showSpinnerEmail: false 
        });
      });
  };

  handleChangeEmail = values => {
    const onlyValidEmails = values.filter(email => isEmail(email));
    this.setState({ emails: onlyValidEmails });
  };

  render() {
    const {
      intl,
      itemShareSelected,
      newColor,
      keyCollection,
      user,
      workclient
    } = this.props;
    const {
      message,
      start,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      loadingButtonLink,
      copyLink,
      showCopyLink,
      users,
      emails,
      plainOptions,
      selectedOption,
      showSpinnerEmail
    } = this.state;

    const optionsUser = users.map(user => {
      return (
        <Option
          key={user._id}
          value={user.email + " " + user.name}
          uid={user._id}
        >
          {`${user.name} (${user.email})`}
        </Option>
      );
    });
    const optionsSpinner = 
    <Option key={'spinner_loading'} >
      <div style={spinnerStyle}>
        <Spin spinning={true} />
      </div>
    </Option>
    return (
      <Form layout="vertical">
        <React.Fragment>
          <Form.Item className="asset-title">
            <span>
              {intl.formatMessage({ id: "share_drawer_title" })}{" "}
              {itemShareSelected.name}
            </span>
          </Form.Item>
          <Form.Item className="asset-img share-modal-view-wrapper">
            {itemShareSelected.type === "image" &&
              fileextension(itemShareSelected.originalURL) === "svg" && (
                <SVGView
                  comFromMiddleView={true}
                  src={itemShareSelected.originalURL}
                  assetId={itemShareSelected._id}
                />
              )}
            {itemShareSelected.type === "image" &&
              fileextension(itemShareSelected.originalURL) !== "svg" && (
                <img
                  alt={itemShareSelected.name}
                  src={itemShareSelected.mediaQualityURL}
                  className="share-modal-img"
                />
              )}
            {itemShareSelected.type === "document" && (
              <DocumentView item={itemShareSelected} from={`middleView`} />
            )}
            {itemShareSelected.type === "video" && (
              <VideoView
                url={itemShareSelected.lowQualityURL}
                disableDefaultControls={false}
                autoPlay={false}
                muted={true}
              />
            )}
          </Form.Item>

          <Form.Item
            label={intl.formatMessage({ id: "multi-share-share-days" })}
          >
            <Row style={{ width: "100%" }}>
              {plainOptions.map(item => {
                return (
                  <Col span={4} key={item}>
                    <Checkbox
                      value={item}
                      onChange={value => {
                        if (selectedOption !== item && showCopyLink) {
                          this.handleSendLinkShare(
                            itemShareSelected,
                            user,
                            workclient,
                            value.target.value
                          );
                        }
                        this.setState({
                          selectedOption: value.target.value
                        });
                      }}
                      checked={selectedOption === item}
                    >
                      {item}
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Form.Item>
          <Form.Item>
            <Tooltip
              title={
                this.isDownloadBlocked()
                  ? intl.formatMessage({ id: "rights_asset_out" })
                  : null
              }
            >
              <span>
                <Button
                  size={"large"}
                  htmlType={"button"}
                  type={"primary"}
                  className="share-modal-button"
                  loading={loadingButtonLink}
                  disabled={this.isDownloadBlocked()}
                  onClick={() =>
                    this.handleSendLinkShare(itemShareSelected, user, workclient)
                  }
                >
                  {intl.formatMessage({ id: "generate_link" })}
                </Button>
              </span>
            </Tooltip>
          </Form.Item>
          {showCopyLink && (
            <Form.Item
              style={{
                marginTop: "-21px"
              }}
            >
              <div style={{ display: "flex" }}>
                <input
                  className="ant-input"
                  value={copyLink}
                  type="text"
                  ref={this.myInputCopyLink}
                />
                <Button
                  type="primary"
                  style={{
                    backgroundColor: newColor,
                    borderColor: newColor,
                    marginLeft: 10
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(copyLink);
                    sendNotification(
                      "success",
                      intl,
                      intl.formatMessage({ id: "link_copied" })
                    );
                    this.props.unsetSelectShareAsset(keyCollection);
                  }}
                >
                  {intl.formatMessage({ id: "copy_link" })}
                </Button>
              </div>
            </Form.Item>
          )}
          <Form.Item
            style={{
              marginTop: "-21px"
            }}
          >
            <span>
              {intl.formatMessage({ id: "add_email" })}
              <Helper
                title={"helper_title"}
                content={"helper_share_asset_content"}
                trigger={`click`}
              />
            </span>
            {/* <Tags
              titleCustom='Agregar direcciones de correo'
              placeholderCustom='Agregar un nuevo correo'
              validateIsEmail={true}
              handleTags={this.handleEmails}
              handleError={this.handleError}
            /> */}
            {/* <TagsV2
              titleCustom={intl.formatMessage({ id: "add_email_adresses" })}
              placeholderCustom={intl.formatMessage({ id: "add_new_email" })}
              validateIsEmail={true}
              handleTags={this.handleEmails}
              handleError={this.handleError}
            /> */}
            {
              <Select
                mode="tags"
                style={{ width: "100%" }}
                onChange={this.handleChangeEmail}
                tokenSeparators={[","]}
                value={emails}
              >
                {showSpinnerEmail && optionsSpinner}
                {optionsUser}
              </Select>
            }
          </Form.Item>
          <Form.Item>
            <Checkbox onChange={this.handleShowPasswordInputs}>
              {intl.formatMessage({ id: "add_password" })}
              <Helper
                title={"helper_title"}
                content={"helper_add_password"}
                trigger={`click`}
              />
            </Checkbox>
            {showPasswordInputs && (
              <Input.Group className="input-group">
                <Input.Password
                  className="pass-input"
                  placeholder="Agregar Contraseña"
                  value={addPassword}
                  autoComplete="new-password"
                  onChange={this.handleAddPass}
                />
                <Input.Password
                  className="pass-input"
                  placeholder="Confirmar Contraseña"
                  value={confirmPassword}
                  autoComplete="new-password"
                  onChange={this.handleConfirmPass}
                />
              </Input.Group>
            )}
          </Form.Item>
          <Form.Item>
            <TextArea
              placeholder={intl.formatMessage({ id: "message" })}
              rows="5"
              value={message}
              onChange={this.handleOnInputChange}
            />
          </Form.Item>
          <Row type={"flex"} justify={"space-between"}>
            <Button
              size={"large"}
              type={"primary"}
              loading={start}
              className="share-modal-button accept"
              onClick={this.handleSendShared}
            >
              {intl.formatMessage({ id: "shared_share" })}
            </Button>
            <Button
              size={"large"}
              type={"primary"}
              ghost
              className="share-modal-button cancel"
              onClick={() => {
                this.props.unsetSelectShareAsset(keyCollection);
                this.props.setkeyboardEnabled(false);
              }}
            >
              {intl.formatMessage({ id: "cancel_button" })}
            </Button>
          </Row>
        </React.Fragment>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;

  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isUpdating: state.assetsRoot.isUpdating,
        itemShareSelected: state.assetsRoot.data.find(r => r.isShareSelected),
        error: state.assetsRoot.error
      };
      break;
    case "assetsLastUploads":
      object = {
        isUpdating: state.assetsLastUploads.isUpdating,
        itemShareSelected: state.assetsLastUploads.data.find(
          r => r.isShareSelected
        ),
        error: state.assetsLastUploads.error
      };
      break;
    case "assetsShared":
      object = {
        isUpdating: state.assetsShared.isUpdating,
        itemShareSelected: state.assetsShared.data.find(r => r.isShareSelected),
        error: state.assetsShared.error
      };
      break;
    case "assetsFavorites":
      object = {
        isUpdating: state.assetsFavorites.isUpdating,
        itemShareSelected: state.assetsFavorites.data.find(
          r => r.isShareSelected
        ),
        error: state.assetsFavorites.error
      };
      break;
    case "assetsExplore":
      object = {
        isUpdating: state.assetsExplore.isUpdating,
        itemShareSelected: state.assetsExplore.data.find(
          r => r.isShareSelected
        ),
        error: state.assetsExplore.error
      };
      break;
    case "searcher":
      object = {
        isUpdating: state.searcher.isUpdating,
        itemShareSelected: state.searcher.data.find(r => r.isShareSelected),
        error: state.searcher.error
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    user: state.authUser.user._id,
    workclient: state.client.data ? state.client.data._id : null,
    isFetching: state.assetsShared.isFetching,
    error: state.assetsShared.error,
    sended: state.assetsShared.sended,
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  sendShareAsset,
  unsetSelectShareAsset,
  setkeyboardEnabled
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareAsset))
);
